import React, { useContext } from "react";
import themeContext from "../../../../context/theme/ThemeContext";

const QCFixIcon = (props) => {
  const { themeName, getThemeColor, getThemeColorForTab} = useContext(themeContext);
  return (

    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
    >
      <path
        d="M13.2085 15H13.9585V12H13.2085V15ZM13.5835 11.25C13.6835 11.25 13.771 11.2125 13.846 11.1375C13.921 11.0625 13.9585 10.975 13.9585 10.875C13.9585 10.775 13.921 10.6875 13.846 10.6125C13.771 10.5375 13.6835 10.5 13.5835 10.5C13.4835 10.5 13.396 10.5375 13.321 10.6125C13.246 10.6875 13.2085 10.775 13.2085 10.875C13.2085 10.975 13.246 11.0625 13.321 11.1375C13.396 11.2125 13.4835 11.25 13.5835 11.25ZM4.5835 16.5C4.171 16.5 3.81787 16.3531 3.52412 16.0594C3.23037 15.7656 3.0835 15.4125 3.0835 15V3C3.0835 2.5875 3.23037 2.23438 3.52412 1.94063C3.81787 1.64687 4.171 1.5 4.5835 1.5H10.5835L15.0835 6V7.725C14.846 7.65 14.6022 7.59375 14.3522 7.55625C14.1022 7.51875 13.846 7.5 13.5835 7.5V6.75H9.8335V3H4.5835V15H8.83975C8.97725 15.2875 9.13662 15.5563 9.31787 15.8063C9.49912 16.0563 9.70225 16.2875 9.92725 16.5H4.5835ZM13.5835 9C14.621 9 15.5054 9.36563 16.2366 10.0969C16.9679 10.8281 17.3335 11.7125 17.3335 12.75C17.3335 13.7875 16.9679 14.6719 16.2366 15.4031C15.5054 16.1344 14.621 16.5 13.5835 16.5C12.546 16.5 11.6616 16.1344 10.9304 15.4031C10.1991 14.6719 9.8335 13.7875 9.8335 12.75C9.8335 11.7125 10.1991 10.8281 10.9304 10.0969C11.6616 9.36563 12.546 9 13.5835 9Z"
        // fill={themeName != "light"?props.active?"white":"#bfbfbf":getThemeColor("icon-color")}
        fill={getThemeColorForTab(props.active)}
      />
    </svg>
  );
};

export default QCFixIcon;
